import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import Note from "../../Assets/images/note.svg";

function ActiveFinancedProgressTab({ stages, lastUpdated, setSelectedPreviewImage }) {
  return (
    <div>
      {stages.length > 0 ? (
        <div>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-[#1E222B] text-[13px] font-[800]">
              Project Progress
            </h3>
            {lastUpdated && (
              <span className="text-[#808285] text-[11px] font-[400]">
                Last updated: {lastUpdated}
              </span>
            )}
          </div>

          <div className="relative pl-0.5 mt-2">
            {stages.map((stage, idx) => {
              const isLast = idx === stages.length - 1;
              const isCompleted = stage.status === "completed";
              return (
                <div
                  key={stage.id || idx}
                  className={`relative flex items-start gap-3 ${
                    !isLast ? "pb-7" : ""
                  }`}
                >
                  {!isLast && (
                    <div
                      className="absolute left-[10.5px] top-[22px] bottom-0 w-[1.5px] bg-[#94A3B8]/35"
                      aria-hidden="true"
                    />
                  )}
                  {isCompleted ? (
                    <div className="relative z-10 w-[22px] h-[22px] rounded-full bg-[#00BC67] flex items-center justify-center flex-shrink-0 shadow-xs">
                      <CheckIcon
                        sx={{
                          fontSize: 13,
                          color: "#FFFFFF",
                          stroke: "#FFFFFF",
                          strokeWidth: 0.5,
                        }}
                      />
                    </div>
                  ) : (
                    <div className="relative z-10 w-[22px] h-[22px] rounded-full bg-[#A3E7CA] flex items-center justify-center flex-shrink-0" />
                  )}
                  <div className="flex-1 -mt-0.5">
                    <div className="flex items-center justify-between">
                      <h4 className="text-[#1E222B] text-[13px] font-[700]">
                        {stage.title || stage.phaseName || "Milestone"}
                      </h4>
                      {(stage.date || stage.createdAt) && (
                        <span className="text-[#808285] text-[11px] font-[400]">
                          {stage.date ||
                            (stage.createdAt
                              ? new Date(stage.createdAt).toLocaleDateString()
                              : "")}
                        </span>
                      )}
                    </div>
                    {(stage.description || stage.phaseDescription) && (
                      <p className="text-[#808285] text-[11.5px] font-[400] mt-0.5 leading-snug">
                        {stage.description || stage.phaseDescription}
                      </p>
                    )}
                    {((Array.isArray(stage.images) &&
                      stage.images.length > 0) ||
                      (Array.isArray(stage.phaseImages) &&
                        stage.phaseImages.length > 0)) && (
                      <div className="flex items-center gap-2 mt-2.5">
                        {(stage.images || stage.phaseImages).map(
                          (img, imgIdx) => (
                            <button
                              key={imgIdx}
                              type="button"
                              onClick={() =>
                                setSelectedPreviewImage(img?.imageUrl || img)
                              }
                              className="w-[66px] h-[66px] sm:w-[70px] sm:h-[70px] rounded-[8px] overflow-hidden bg-[#F1F5F9] cursor-pointer hover:opacity-90 transition-opacity flex-shrink-0 border border-black/5 shadow-2xs"
                              aria-label={`View progress image ${imgIdx + 1}`}
                            >
                              <img
                                src={img?.imageUrl || img}
                                alt={`Progress thumbnail ${imgIdx + 1}`}
                                className="w-full h-full object-cover"
                              />
                            </button>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-[16px] border border-dashed border-gray-200 p-8 text-center flex flex-col items-center justify-center my-4">
          <img
            src={Note}
            alt="No updates"
            className="w-14 h-14 opacity-50 mb-3"
          />
          <h4 className="text-[#1E222B] font-[700] text-[14px] mb-1">
            No Updates Yet
          </h4>
          <p className="text-[#808285] text-[12px] max-w-xs leading-relaxed">
            Project updates will appear here.
          </p>
        </div>
      )}
    </div>
  );
}

export default ActiveFinancedProgressTab;
